import { useMutation } from '@tanstack/react-query'
import { request } from 'Lib/axios'
import { useUserStore } from 'Stores/userStoreModuleFed'

type InvoiceDownloadResponse = {
  downloadLink: string
  invoiceId: string
}

const getInvoiceDownloadLink = (accountId: number, invoiceId: number) =>
  request<{ data: InvoiceDownloadResponse }>({
    url: `accounts/${accountId}/subscriptions/invoices/${invoiceId}`,
    method: 'GET',
  })

export const useGetInvoiceDownloadLink = () => {
  const { accountId } = useUserStore()

  return useMutation({
    mutationFn: (invoiceId: number) => getInvoiceDownloadLink(accountId, invoiceId),
  })
}
